import { MutationTree } from 'vuex'
import { ResponseArray } from '../types'
import { blankInquiry, blankInquiryArray } from './constants'
import State, { IInquiry, ISearchFilters } from './types'
import _ from 'lodash'
import { IOrderCustomer, IOrderDocument } from '../orders/types'

export const mutations: MutationTree<State> = {
  inquiriesLoading(state: State) {
    state.error = false
    state.inquiries = blankInquiryArray
  },
  inquiriesLoaded(state: State, inquiries: ResponseArray<IInquiry>) {
    state.error = false
    state.inquiries = inquiries
  },
  customersLoaded(state: State, customers: ResponseArray<IOrderCustomer>) {
    state.error = false
    state.customers = customers
  },
  inquiriesError(state) {
    state.error = true
    state.inquiries = blankInquiryArray
  },
  activeInquirySet(state, activeInquiry: IInquiry) {
    state.activeInquiry = activeInquiry
    state.inquiryChanged = false
  },
  activeInquiryError(state) {
    state.activeInquiry = blankInquiry
    state.inquiryChanged = false
  },
  inquiryAdding(state) {
    state.isSubmittingInquiry = true
    state.submissionError = ''
  },
  inquiryAdded(state, activeInquiry: IInquiry) {
    state.activeInquiry = activeInquiry
    state.isSubmittingInquiry = false
    state.inquiryChanged = false
  },
  inquiryAddedError(state, errorMsg) {
    state.isSubmittingInquiry = false
    state.error = true
    state.submissionError = errorMsg
  },
  inquiryCancelError(state, errorMsg) {
    state.submissionError = errorMsg
  },
  inquiryChanged(state) {
    state.inquiryChanged = true
  },
  setPage: (state, { page }: { page: number }) => {
    state.page = page
  },
  isSubmittingSet(state, isSubmittingInquiry) {
    state.isSubmittingInquiry = isSubmittingInquiry
  },
  currentInquirySet(state, currentInquiry: IInquiry) {
    state.currentInquiry = currentInquiry
    state.validationErrors = {}
  },
  currentInquiryError(state) {
    state.currentInquiry = _.cloneDeep(blankInquiry)
  },
  currentInquiryReset(state) {
    state.currentInquiry = _.cloneDeep(blankInquiry)
    state.validationErrors = {}
  },
  validationErrorsSet(state, { key, list }: any) {
    if (Object.keys(state.validationErrors).length === 0) {
      state.validationErrors = { [key]: { ...list } }
    } else {
      state.validationErrors[key] = { ...list }
    }
  },
  validationErrorsError(state) {
    state.validationErrors = {}
  },
  inquiryEditorOpenOnItemsTabSet(state: State, value: boolean) {
    state.inquiryEditorOpenOnItemsTab = value
  },
  inquiryListTabRemember(state: State, status: string) {
    const allowed = ['Open', 'Pending', 'Approved', 'Cancelled']
    if (allowed.includes(status)) {
      state.rememberedInquiryListTab = status
    }
  },
  searchFiltersSet(state: State, searchFilters: ISearchFilters) {
    state.searchFilters = { ...state.searchFilters, ...searchFilters }
  },
  inquiryDocumentsLoading(state) {
    state.inquiryDocuments = []
    state.documentsLoading = true
  },
  inquiryDocumentsSet(state, documents: IOrderDocument[]) {
    state.inquiryDocuments = documents
    state.documentsLoading = false
  },
  inquiryDocumentError(state, errorMsg) {
    state.documentsLoading = false
    state.submissionError = errorMsg
  },
  setCurrentCustomer(state: State, { customerNo, divisionCode, divisionText }: { customerNo: string, divisionCode: string, divisionText: string }) {
    state.currentCustomer = { customerNo, divisionCode, divisionText }
  },
}
